var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup163282(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 404.5,
    height: 26,
    viewBox: "0 0 404.5 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163282",
    "data-name": "Group 163282",
    transform: "translate(-31 -309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163189",
    "data-name": "Group 163189",
    transform: "translate(0.421 143.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_731",
    "data-name": "Ellipse 731",
    transform: "translate(30.579 165.579)",
    fill: "#6c63ff",
    stroke: "#1b1c1d",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 11.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x1: 372.5,
    transform: "translate(63 322)",
    fill: "none",
    stroke: "#efefef",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup163282);
export default __webpack_public_path__ + "static/media/Group 163282.9893e45133de7797e7dc8c0ee44a7a99.svg";
export { ForwardRef as ReactComponent };